'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = percy;

var _getCommonInterface = require('./getCommonInterface');

var _getCommonInterface2 = _interopRequireDefault(_getCommonInterface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function percy(context, suites) {
  var common = (0, _getCommonInterface2.default)(suites);

  context.before = context.beforeAll = common.beforeAll;
  context.beforeEach = common.beforeEach;
  context.afterEach = common.afterEach;
  context.after = context.afterAll = common.afterAll;
  context.percySnapshot = common.snapshot;
  context.suite = common.suite;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@percy/react-percy-test-framework/lib/interfaces/percy.js
// module id = 477
// module chunks = 1